import * as z from "zod";

export const getAiReturnReasonsForProduct = {
  name: "getAiReturnReasonsForProduct" as const,
  input: z.object({
    productId: z.string(),
    /** Draft return type; selects the warranty pool for warranties. */
    returnType: z.string().optional(),
  }),
  output: z.object({ reasons: z.array(z.string()) }),
};
